/**
 * 工作区类型枚举
 */
export enum WorkspaceType {
  /** 个人空间 */
  Personal = 0,
  /** 组织空间 */
  Organization = 1,
}

/**
 * 工作区信息
 */
export interface Workspace {
  id: string
  name: string
  icon?: string
  /** 空间类型：0个人 1组织 */
  type: WorkspaceType
  createTime: string
  creator: string
  userId: string
  createdAt: string
  updatedAt: string
}

/**
 * 获取工作区成员列表请求参数
 */
export interface GetWorkspaceMembersRequest {
  /** 输入框查询字段 */
  search?: string
  /** 用户id（指定用户） */
  userId?: number
  /** 工作空间id */
  workspaceId: number
  [property: string]: any
}

/**
 * 空间成员列表
 */
export interface WorkspaceMemberListRes {
  members?: WorkspaceMemberVO[]
  [property: string]: any
}

/**
 * 空间成员表
 */
export interface WorkspaceMemberVO {
  /** 头像 */
  avatar?: string
  /** 创建时间（时间戳） */
  createTime?: number
  /** 是否当前登录用户 */
  isCurrentUser?: number
  /** 是否空间拥有者 */
  isOwner?: number
  /** 手机号 */
  phone?: string
  /** 用户表id（字符串类型） */
  userId?: string
  /** 用户名 */
  userName?: string
  /** 工作空间id（字符串类型） */
  workspaceId?: string
  [property: string]: any
}

/**
 * 移除空间成员请求参数
 */
export interface RemoveMemberRequest {
  /** 被移除的用户id */
  userId: string
  /** 工作空间id */
  workspaceId: string
  [property: string]: any
}

/**
 * 生成邀请链接请求参数
 */
export interface GenerateInviteLinkRequest {
  /** 工作空间id */
  workspaceId?: string
  [property: string]: any
}

/**
 * 邀请链接表
 */
export interface InvitationLinkRes {
  /** 邀请url */
  invitationUrl?: string
  [property: string]: any
}

/**
 * InviteMsgRes，邀请信息
 */
export interface InviteMsgRes {
  /**
   * 邀请人名称
   */
  inviters?: string
  /**
   * 邀请人头像
   */
  invitersAvatar?: string
  /**
   * 空间图标
   */
  workspaceIcon?: string
  /**
   * 空间名称
   */
  workspaceName?: string
  /**
   * 工作空间ID
   */
  workspaceId?: string
  [property: string]: any
}

/**
 * 获取邀请信息请求参数
 */
export interface GetInviteMsgRequest {
  code: string
}

/**
 * 接受邀请请求参数
 */
export interface AcceptInviteRequest {
  code: string
}

/**
 * 转让工作区所有权请求参数
 */
export interface TransferWorkspaceRequest {
  /** 接收转让的用户ID */
  toUserId: string
  /** 工作空间id */
  workspaceId: string
  [property: string]: any
}

/**
 * 删除工作区请求参数
 */
export interface DeleteWorkspaceRequest {
  /** 工作空间id */
  id: string
  [property: string]: any
}

/**
 * 退出工作区请求参数
 */
export interface LeaveWorkspaceRequest {
  /** 工作空间id */
  id: string
  [property: string]: any
}
